"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BadgeConstants = require("../badge/BadgeConstants");

var _UIBadge = _interopRequireDefault(require("../badge/UIBadge"));

var _ribbonStyles = require("./internal/ribbonStyles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  position: absolute;\n  top: 8px;\n  ", ";\n  z-index: 1;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BADGE_TYPES = {
  beta: null,
  free: null,
  new: null
};
var BADGE_USES = (0, _extends2.default)({}, BADGE_TYPES, _BadgeConstants.BADGE_COLORS);
var Badge = (0, _styledComponents.default)(_UIBadge.default).withConfig({
  displayName: "UIRibbon__Badge",
  componentId: "sc-1x458ly-0"
})(_templateObject(), function (_ref) {
  var position = _ref.position;
  return (0, _ribbonStyles.setRibbonRounding)(position);
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'right' ? 'right: -4px' : 'left: -4px';
});

var _default = _react.default.createClass({
  displayName: "UIRibbon",
  propTypes: {
    position: _react.PropTypes.oneOf(['left', 'right']).isRequired,
    children: _react.PropTypes.node,
    use: _react.PropTypes.oneOf(Object.keys(BADGE_USES)).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      position: 'right',
      use: 'new'
    };
  },
  render: function render() {
    return _react.default.createElement(Badge, this.props);
  }
});

exports.default = _default;
module.exports = exports.default;